import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function InfoSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-gray-50 py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
        
        {/* Devenir Étudiant Card - NSCC Architecture */}
        <div className="bg-white p-8 md:p-12 border-t-[12px] border-navy shadow-xl flex flex-col items-start h-full group hover:shadow-2xl transition-all duration-500 rounded-sm">
          <h2 className="text-navy text-3xl font-black mb-6 uppercase tracking-tighter">
            {t('admissions_hero_badge', 'Devenir Étudiant')}
          </h2>
          <p className="text-gray-600 text-lg mb-10 leading-relaxed font-light">
            {t('hero_card_intro_student', "Rejoignez notre communauté dynamique et commencez votre parcours vers l'excellence dès aujourd'hui. Candidatures ouvertes pour la session 2026.")}
          </p>
          <Link 
            to="/admissions" 
            className="mt-auto bg-gold text-white font-bold py-4 px-10 rounded-sm uppercase tracking-widest shadow-md hover:brightness-110 hover:shadow-lg transition-all duration-300 active:scale-95"
          >
            {t('hero_cta_apply', 'Postuler Maintenant')}
          </Link>
        </div>

        {/* Informations Pour Card - NSCC Architecture */}
        <div className="bg-white p-8 md:p-12 border-t-[12px] border-navy shadow-xl flex flex-col h-full rounded-sm">
          <h2 className="text-navy text-3xl font-black mb-10 uppercase tracking-tighter">
            {t('info_for_title', 'Informations pour :')}
          </h2>
          <div className="space-y-5 w-full">
            <Link 
              to="/admissions/international" 
              className="group flex items-center justify-between bg-gray-50 p-6 border-l-[6px] border-gold hover:bg-navy transition-all duration-300"
            >
              <span className="text-navy font-black text-xl group-hover:text-white transition-colors">
                {t('info_international_students', 'Étudiants Internationaux')}
              </span>
              <ChevronRight className="w-8 h-8 text-navy group-hover:text-white group-hover:translate-x-2 transition-all" />
            </Link>
            <Link 
              to="/partnerships" 
              className="group flex items-center justify-between bg-gray-50 p-6 border-l-[6px] border-gold hover:bg-navy transition-all duration-300"
            >
              <span className="text-navy font-black text-xl group-hover:text-white transition-colors">
                {t('info_partners_industry', 'Partenaires & Entreprises')}
              </span>
              <ChevronRight className="w-8 h-8 text-navy group-hover:text-white group-hover:translate-x-2 transition-all" />
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}
